export default "__VITE_PUBLIC_ASSET__8ae8c90a__"